import React from "react";
import styled from "@emotion/styled";
import { keyframes } from "@emotion/react";
import { text, borderRadius } from "@atlas-int/tokens";

const spin = keyframes`
  from { transform: rotate(0deg); }
  to { transform: rotate(360deg); }
`;

const sizeMap = {
  sm: "16px",
  md: "32px",
  lg: "48px",
} as const;

const borderMap = {
  sm: "2px",
  md: "3px",
  lg: "4px",
} as const;

export type SpinnerSize = "sm" | "md" | "lg";

export interface SpinnerProps {
  size?: SpinnerSize;
  color?: string;
  className?: string;
}

const StyledSpinner = styled.span<{
  $size: SpinnerSize;
  $color: string;
}>`
  display: inline-block;
  width: ${({ $size }) => sizeMap[$size]};
  height: ${({ $size }) => sizeMap[$size]};
  border: ${({ $size }) => borderMap[$size]} solid ${({ $color }) => $color};
  border-right-color: transparent;
  border-radius: ${borderRadius.full};
  animation: ${spin} 0.7s linear infinite;
  flex-shrink: 0;
`;

const Spinner = React.forwardRef<HTMLSpanElement, SpinnerProps>(
  ({ size = "md", color = text.secondary, className }, ref) => (
    <StyledSpinner
      ref={ref}
      $size={size}
      $color={color}
      className={className}
      role="status"
      aria-label="Loading"
    />
  ),
);

Spinner.displayName = "Spinner";

export default Spinner;
